import type { SetNode } from './types';

/**
 * Every row, in order, with its route and icon (spec 15 §2.2).
 *
 * Rows whose page is not built yet (`Phone numbers`, `Cancellation policy`, the
 * six agent leaves) are still rendered and route to a placeholder — the menu is
 * the inventory (§2.3). `Accounts receivable` may be locked per location.
 */
export const SETTINGS_NAV_ROWS: SetNode[] = [
  { kind: 'divider', key: 'd-general', label: 'General' },
  {
    kind: 'group',
    key: 'practice',
    label: 'Practice management',
    icon: 'cog',
    children: [
      { key: 'general', label: 'General info', route: '/settings/general' },
      { key: 'providers', label: 'Providers', route: '/settings/providers' },
      { key: 'operatories', label: 'Operatories', route: '/settings/operatories' },
      { key: 'insurance', label: 'Insurance & network', route: '/settings/insurance' },
      { key: 'phone-numbers', label: 'Phone numbers', route: '/settings/phone-numbers' },
    ],
  },
  {
    kind: 'group',
    key: 'booking',
    label: 'Appointment & booking',
    icon: 'calendar',
    children: [
      { key: 'reasons', label: 'Appointment reasons', route: '/settings/appointment-reasons' },
      { key: 'online-booking', label: 'Online booking', route: '/settings/online-booking' },
      { key: 'insights', label: 'Calendar insights', route: '/settings/calendar-insights' },
      { key: 'cancellation', label: 'Cancellation policy', route: '/settings/cancellation-policy' },
    ],
  },
  { kind: 'divider', key: 'd-brain', label: 'AI Brain' },
  { kind: 'leaf', key: 'ai-general', label: 'General', icon: 'bolt', route: '/settings/ai/general' },
  {
    kind: 'leaf',
    key: 'ai-train',
    label: 'Train ELVA',
    icon: 'sparkle',
    route: '/settings/ai/train',
    badge: 'trainElva',
  },
  { kind: 'leaf', key: 'ai-kb', label: 'Knowledge base', icon: 'clipboard', route: '/settings/ai/knowledge-base' },
  {
    kind: 'group',
    key: 'channels',
    label: 'Channels',
    icon: 'phone',
    children: [
      { key: 'ch-call', label: 'Call', route: '/settings/ai/channels/call' },
      { key: 'ch-sms', label: 'SMS', route: '/settings/ai/channels/sms' },
      { key: 'ch-email', label: 'Email', route: '/settings/ai/channels/email' },
    ],
  },
  { kind: 'leaf', key: 'ag-recep', label: 'AI Receptionist', icon: 'headphones', route: '/settings/ai/receptionist' },
  // AI SMS / AI Email open the existing Channels pages — they already hold
  // "What ELVA can do" for that channel, so there are no new pages (spec 36 §7 rev).
  { kind: 'leaf', key: 'ag-sms', label: 'AI SMS', icon: 'chat', route: '/settings/ai/channels/sms' },
  { kind: 'leaf', key: 'ag-email', label: 'AI Email', icon: 'mail', route: '/settings/ai/channels/email' },
  { kind: 'leaf', key: 'ag-reminders', label: 'Appointment Reminders', icon: 'bell', route: '/settings/ai/reminders' },
  { kind: 'leaf', key: 'ag-recall', label: 'Recall', icon: 'refresh', route: '/settings/ai/recall' },
  { kind: 'leaf', key: 'ag-gap', label: 'Gap Filler', icon: 'clock', route: '/settings/ai/gap-filler' },
  {
    kind: 'leaf',
    key: 'ag-treatment',
    label: 'Treatment Coordinator',
    icon: 'team',
    route: '/settings/ai/treatment-coordinator',
  },
  { kind: 'leaf', key: 'ag-invisalign', label: 'Invisalign Coordinator', icon: 'gem', route: '/settings/ai/invisalign' },
  {
    kind: 'leaf',
    key: 'ag-ar',
    label: 'Accounts receivable',
    icon: 'dollar',
    route: '/settings/ai/accounts-receivable',
  },
];
